
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/automotive",
      function () {
        return require("private-next-pages/automotive.js");
      }
    ]);
  